const timeInMinutes = {
  hour: 60,
  twoHours: 120,
  day: 1440,
  twoDays: 2880,
  month: 43200,
  twoMoths: 86400,
  year: 525600,
  twoYears: 1051200,
};

function lessThanADay(distanceInMinutes) {
  if (distanceInMinutes === 0) { return 'menos de um minuto atrás'; }
  if (distanceInMinutes === 1) { return '1 minuto atrás'; }
  if (distanceInMinutes < timeInMinutes.hour) { return `${distanceInMinutes} minutos atrás`; }
  return (distanceInMinutes < timeInMinutes.twoHours ? '1 hora atrás' : `${Math.floor(distanceInMinutes / 60)} horas atrás`);
}

function lessThanAYear(distanceInMinutes) {
  if (distanceInMinutes < timeInMinutes.twoDays) { return '1 dia atrás'; }
  if (distanceInMinutes < timeInMinutes.month) { return `${Math.floor(distanceInMinutes / timeInMinutes.day)} dias atrás`; }
  if (distanceInMinutes < timeInMinutes.twoMoths) { return '1 mes atrás'; }
  return `${Math.floor(distanceInMinutes / timeInMinutes.month)} meses atrás`;
}

function moreThanAYear(distanceInMinutes) {
  if (distanceInMinutes < timeInMinutes.twoYears) { return '1 ano atrás'; }

  return `mais de ${Math.floor(distanceInMinutes / timeInMinutes.year)} anos atrás`;
}

function intervalTimeInMinutes(date) {
  const when = new Date().setTime(Date.parse(date));
  const today = new Date();

  return Math.abs(Math.floor(((when - today) / 1000) / 60));
}
function timeAgoInWords(date) {
  const distanceInMinutes = intervalTimeInMinutes(date);

  if (distanceInMinutes < timeInMinutes.day) { return lessThanADay(distanceInMinutes); }
  if (distanceInMinutes < timeInMinutes.year) { return lessThanAYear(distanceInMinutes); }
  return moreThanAYear(distanceInMinutes);
}

export default timeAgoInWords;
